import { datadogRum } from '@datadog/browser-rum';
export default defineNuxtRouteMiddleware(async (to, from) => {
  // possibly cache user details to avoid a call on every page

  if (to.fullPath !== '/manage-jobs') {
    const { data, error } = await useAcvFetch(`api/user/userdetails`);
    const status = error.value ? error.value.statusCode : null;

    /**
     * If a user has an existing Auth0 ID but they are attempting
     * to use a different sign in method provide a prompt to sign in with the correct credentials
     */
    if (status && status === 409) {
      return navigateTo('/409');
    }

    if (status && (status === 404 || status === 401)) {
      return navigateTo('/signup');
    }

    if (data?.value?.data?.role === 'New') {
      return navigateTo('/account-pending');
    }

    if (!data?.value?.data?.termsAccepted) {
      return navigateTo('/legal');
    }

    if (data.value) {
      const user = data.value.data;

      if (useIsRestrictedUser({ ...user })) {
        return navigateTo('/403', { query: { src: 'middleware' } });
      } else {
        const postalCode = data.value.data?.carrier?.postalCode
          ? data.value.data?.carrier?.postalCode
          : '';

        sessionStorage.setItem('postalCode', JSON.stringify(postalCode));
        localStorage.setItem('user', JSON.stringify(data.value));

        if (import.meta.env.PROD) {
          datadogRum.setUser({ id: user.id, ...user });
        }
      }
    }
  }
});
